import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_8 = { class: "m-0" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "¿Participa de la asamblea?", -1)
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Procedencia", -1)
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = {
  key: 2,
  class: "row"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, "Organización a la que representa", -1)
const _hoisted_20 = { class: "col-sm-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t('acrd7')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            class: "form form-label-right"
          }, {
            default: _withCtx(() => [
              (_ctx.itemFunction?.note)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.itemFunction?.note), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('acrd8')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_form_item, {
                    prop: "idfunction",
                    rules: [
                                    {
                                        required: true,
                                        message: 'Este campo es requerido',
                                        trigger: ['blur', 'change'],
                                    },
                                ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.idfunction,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.idfunction) = $event)),
                        filterable: "",
                        placeholder: _ctx.t('seleccione'),
                        class: "w-100",
                        onChange: _ctx.getMessageFunction
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFunctions, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: `lstpo-${index}`,
                              label: item.name,
                              value: item.idfunction
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "onChange"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.sport && _ctx.sport.idsport == 54)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_el_form_item, {
                        prop: "param1",
                        rules: [
                                    {
                                        required: true,
                                        message: 'Este campo es requerido',
                                        trigger: ['blur', 'change'],
                                    },
                                ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.param1,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.param1) = $event)),
                            placeholder: _ctx.t('seleccione'),
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: 'SI',
                                value: 'SI'
                              }),
                              _createVNode(_component_el_option, {
                                label: 'NO',
                                value: 'NO'
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_form_item, {
                    prop: "elofide",
                    rules: [
                                    {
                                        required: false,
                                        message: 'Este campo es requerido',
                                        trigger: ['blur', 'change'],
                                    },
                                ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.faculty,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.faculty) = $event)),
                        class: "w-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.form.idfunction == 338)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_form_item, {
                        prop: "titlefide",
                        rules: [
                                    {
                                        required: true,
                                        message: 'Este campo es requerido',
                                        trigger: ['blur', 'change'],
                                    },
                                ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.titlefide,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.titlefide) = $event)),
                            class: "w-100"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loader]
  ])
}